module.exports = __webpack_public_path__ + "img/swap.fcaa6d18.svg";